import { createTheme, responsiveFontSizes } from '@mui/material/styles'

// Base Theme Config
let theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1565c0',
    },
    secondary: {
      main: '#ff9800',
    },
    background: {
      default: '#fafafa',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontSize: 14, // base font size (will scale)
    h6: {
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.9rem',
    },
  },
  shape: {
    borderRadius: 8,
  },
  spacing: 8, // MUI default spacing unit
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        size: 'medium',
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: 'md',
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,   // Tablets / small Chromebooks
      md: 960,   // Standard Chromebooks
      lg: 1280,
      xl: 1920,
    },
  },
})

theme = responsiveFontSizes(theme)

export default theme
